import { Box, Typography } from "@mui/material";
import { useCookies } from "react-cookie";
import { IOSSwitch } from "../atoms";

export const SystemModeView = () => {
  const [cookie, setCookie] = useCookies(["APPLICATION_MODE"]);
  return (
    <Box sx={{ display: "flex", gap: "16px", "& > span": { whiteSpace: "nowrap" } }}>
      <Typography component={"span"} sx={{ color: cookie.APPLICATION_MODE === "test" ? "error.dark" : "success.main" }}>
        {cookie.APPLICATION_MODE !== "test" ? "Live Mode" : "Test Mode"}
      </Typography>
      <IOSSwitch
        sx={{
          "&.MuiSwitch-root .MuiSwitch-track": {
            backgroundColor: "error.dark",
          },
        }}
        checked={cookie.APPLICATION_MODE !== "test"}
        onChange={() => {
          var mode = cookie.APPLICATION_MODE || "live";
          setCookie("APPLICATION_MODE", mode === "live" ? "test" : "live", {
            path: "/",
          });
          window.location.reload();
        }}
      />
    </Box>
  );
};
